export const Data = [
    // Enter data here to increase the number of products on main page.
    {
        name:"Blog/Article",
        desc:"this is good this is good this is good this is good this is good this is good",
        price:"$100",
        img_path : 'assets/1060-536x354-blur_2.jpg'
    }, 
    {
        name:"Blog/Article",
        desc:"this is good this is good this is good this is good this is good this is good",
        price:"$100",
        img_path : 'assets/1060-536x354-blur_2.jpg'
    },
    {
        name:"Blog/Article",
        desc:"this is good this is good this is good this is good this is good this is good",
        price:"$100",
        img_path : 'assets/1060-536x354-blur_2.jpg'
    },
    {
        name:"Blog/Article",
        desc:"this is good this is good this is good this is good this is good this is good",
        price:"$100",
        img_path : 'assets/1060-536x354-blur_2.jpg'
    },
    {
        name:"Blog/Article",
        desc:"this is good this is good this is good this is good this is good this is good",
        price:"$100",
        img_path : 'assets/1060-536x354-blur_2.jpg'
    },
    {
        name:"Blog/Article",
        desc:"this is good this is good this is good this is good this is good this is good",
        price:"$100",
        img_path : 'assets/1060-536x354-blur_2.jpg'
    },
    {
        name:"Blog/Article",
        desc:"this is good this is good this is good this is good this is good this is good",
        price:"$100",
        img_path : 'assets/1060-536x354-blur_2.jpg'
    },
    {
        name:"Blog/Article",
        desc:"this is good this is good this is good this is good this is good this is good",
        price:"$100",
        img_path : 'assets/1060-536x354-blur_2.jpg'
    },
    {
        name:"Blog/Article",
        desc:"this is good this is good this is good this is good this is good this is good",
        price:"$100",
        img_path : 'assets/1060-536x354-blur_2.jpg'
    }
]